export enum CONTRACT_STATUS {
  awaitingPrepayment = 'awaiting_prepayment',
  prepaymentOverdue = 'prepayment_overdue',
  readyToUse = 'ready_to_use',
  used = 'used',
  expired = 'expired',
  cancelled = 'cancelled',
}

export interface IContractInput {
  sellAmount: number;
  sellCurrency: string;
  buyAmount: number;
  buyCurrency: string;
  rate: number; //1.2345
  expiryDate: string; //YYYY-MM-DD

  feeRate: number; //0.0089 for 0.89%
  feeAmount: number;
  flexFeeAmount?: number;
  conversionFeeRate: number;

  totalAmount: number; //sellAmount + feeAmount
  prepaymentAmount?: number; //flexFeeAmount

  bookingName?: string;
  invoiceId?: string;
}

export interface IRateContract extends IContractInput {
  id: string;
  _shortId: string; //e.g. CNG7F4R
  _created: any;
  _createdBy: string;
  _updated?: any;
  _updatedBy?: string;
  status: CONTRACT_STATUS;
  remainingBuyAmount: number;
  numberOfTransfers: number;
  prepaymentPayByDate: string;
  // Only used for optional Fixed Deposits
  depositRate?: number; // 0.05 for 5%
  depositAmount?: number;
  remainingDeposit?: number; // Only used for optional Fixed Deposits
  balanceAmount?: number; // sellAmount - depositAmount
  whenFundsArriveAction?: 'notifyViaEmail' | 'convertAndTransfer';
}
